import { Typography } from "@mui/material";
import moment from "moment";

import { lessonType } from "../../../../constants";
import { useLearning } from "../hooks/useLearning";

export function LessonInfo() {
	const { currentBooking } = useLearning();

	if (!currentBooking) {
		return null;
	}

	const lesson = currentBooking.lesson;

	return (
		<div className="item-separator-small">
			<Typography className="big-text bold">{lesson.title}</Typography>
			<Typography
				className="normal-text"
				whiteSpace="break-spaces"
				textAlign="justify">
				{lesson.description}
			</Typography>
			{lesson.type === lessonType.ONSITE && (
				<div className="lesson-time-container item-separator-small">
					{currentBooking.startTime && currentBooking.endTime && (
						<div>
							<Typography className="normal-text bold">
								Appointment Date
							</Typography>
							<Typography className="normal-text">
								{`${moment(currentBooking.startTime).format("ddd, DD MMM, YYYY")}, ${moment(currentBooking.startTime).format("HH:mm")} - ${moment(currentBooking.endTime).format("HH:mm")}`}
							</Typography>
						</div>
					)}
					{lesson.teachingTime && (
						<div>
							<Typography className="normal-text bold">
								Teaching Time
							</Typography>
							<Typography className="normal-text">{`${(lesson.teachingTime / 60).toFixed(1)} hrs`}</Typography>
						</div>
					)}
					{lesson.flightTime && (
						<div>
							<Typography className="normal-text bold">Flight Time</Typography>
							<Typography className="normal-text">{`${(lesson.flightTime / 60).toFixed(1)} hrs`}</Typography>
						</div>
					)}
					{lesson.airplane && (
						<div>
							<Typography className="normal-text bold">
								Aircraft or Sim Type
							</Typography>
							<Typography className="normal-text">{lesson.airplane}</Typography>
						</div>
					)}
				</div>
			)}
		</div>
	);
}
